import { render, staticRenderFns } from "./law.vue?vue&type=template&id=f3cac3a2&"
import script from "./law.vue?vue&type=script&lang=js&"
export * from "./law.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports